/**
 * Return the canonical raw damage total for an attack-resolution display.
 *
 * The damage roller has historically shown rolled damage rather than HP loss
 * after mitigation. `resolveAttack` owns this value and includes every approved
 * DamageComponent in `result.damage`.
 */
export const getAttackDisplayDamage = (result) => {
  const damage = Number(result?.damage);
  return Number.isFinite(damage) ? damage : null;
};

/** Return the authoritative final attack-roll total produced by resolveAttack. */
export const getAttackDisplayRoll = (result) => {
  const attackTotal = Number(result?.attackTotal);
  return Number.isFinite(attackTotal) ? attackTotal : null;
};

/** Select the value that remains on the shared roll surface after resolution. */
export const getResolvedAttackDisplayValue = (result) => result?.outcome === 'miss'
  ? getAttackDisplayRoll(result)
  : getAttackDisplayDamage(result);
